import { create } from 'zustand';

const useSearchStore = create((set, get) => ({
  results: {},
  clear: () => set(() => ({ results: {} })),

  query: '',
  mode: 'global',
  localSearch: null,
  localQueries: {},

  setQuery: (query) => set({ query }),
  setMode: (mode) => set({ mode }),

  registerLocalSearch: (config) => {
    const savedQuery = get().localQueries[config.key] || '';
    set({ localSearch: config, mode: 'local', query: savedQuery, results: {} });
    if (savedQuery && config.onSearch) {
      config.onSearch(savedQuery);
    }
  },
  unregisterLocalSearch: () => {
    const { localSearch, query } = get();
    const updatedQueries = { ...get().localQueries };
    if (localSearch?.key) {
      updatedQueries[localSearch.key] = query;
    }
    set({ localSearch: null, mode: 'global', query: '', localQueries: updatedQueries });
  },
}));

export default useSearchStore;
